import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper } from "@material-ui/core";
import { Title } from "App/Component/ui";
import { RenderListPaket } from "./ui";

import { FormContext, FormProvider } from "./context/FormContext";
import { getPaketListById } from "./helpers";
import { MOBILE_INPUT_PAKET_TELEKONSUL } from "App/constants";
import { isNull } from "App/utils/helpers";
import FormInput from "./ui/FormInput/FormInput";
import React, { useContext, useEffect, useRef } from "react";
// import { isNull } from "App/utils/helpers";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function InputPaketTelekonsul(props) {
  const classes = useStyles();
  const { data, menu } = props;
  return (
    <FormProvider data={data} menu={menu}>
      <div className={classes.root}>
        <Title title={"Input Paket Telekonsul"} />
        <Paper className={classes.paper}>
          <RenderContent
            classes={classes}
            data={menu === MOBILE_INPUT_PAKET_TELEKONSUL ? data : null}
          />
        </Paper>
      </div>
    </FormProvider>
  );
}

const RenderContent = ({ classes, data }) => {
  const namaInputRef = useRef(null);
  const { setListPaket, formData } = useContext(FormContext);

  useEffect(() => {
    setNewDataPaketList(data?.id);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPaketList = async (paketID) => {
    await getListPaket(paketID);
  };

  const getListPaket = async (paketID) => {
    if (!isNull(paketID)) {
      const res = await getPaketListById(paketID);
      if (res.state) {
        // setFormData(res.data);
        setListPaket(res.detail);
      } else {
        // setFormData(FORM_RESET_STATE_PAKET_TELE);
        setListPaket([]);
      }
    }
  };

  return (
    <>
      <FormInput setNewDataPaketList={setNewDataPaketList} />

      {isNull(formData.id) ? (
        <></>
      ) : (
        <>
          <div className="mt-2"></div>
          <RenderListPaket
            classes={classes}
            setNewDataPaketList={setNewDataPaketList}
            namaInputRef={namaInputRef}
          />
        </>
      )}
    </>
  );
};
